module.exports = __webpack_public_path__ + "img/table2.4fe287b1.png";